/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Header_Togglemenu1Inputs */

const zh_landing_header_togglemenu1 = /** @type {(inputs: Landing_Header_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换菜单`)
};

const en_landing_header_togglemenu1 = /** @type {(inputs: Landing_Header_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle menu`)
};

const es_landing_header_togglemenu1 = /** @type {(inputs: Landing_Header_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar menú`)
};

/**
* | output |
* | --- |
* | "Toggle menu" |
*
* @param {Landing_Header_Togglemenu1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_header_togglemenu1 = /** @type {((inputs?: Landing_Header_Togglemenu1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Header_Togglemenu1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_header_togglemenu1(inputs)
	if (locale === "en") return en_landing_header_togglemenu1(inputs)
	return es_landing_header_togglemenu1(inputs)
});
export { landing_header_togglemenu1 as "landing_header_toggleMenu" }